module.exports = __webpack_public_path__ + "assets/img/ic-openAccount.fc3a5d5c.svg";